import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconNotification = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 19.876 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M19.633,19.263 C19.346,19.731 18.829,20.000 18.217,20.000 L13.894,20.000 C13.894,22.205 12.111,24.000 9.920,24.000 C7.729,24.000 5.947,22.205 5.947,20.000 L1.626,20.000 C1.014,20.000 0.497,19.731 0.210,19.263 C-0.077,18.795 -0.085,18.209 0.188,17.658 L2.969,12.735 L2.969,7.000 C2.969,3.140 6.087,0.000 9.920,0.000 C13.754,0.000 16.874,3.140 16.874,7.000 L16.874,12.735 L19.630,17.611 C19.928,18.209 19.921,18.795 19.633,19.263 ZM9.920,22.000 C11.016,22.000 11.908,21.103 11.908,20.000 L7.933,20.000 C7.933,21.103 8.824,22.000 9.920,22.000 ZM15.018,13.494 C14.876,13.244 14.859,12.960 14.938,12.705 L14.938,7.251 C14.916,7.169 14.888,7.089 14.888,7.000 C14.888,4.243 12.659,2.000 9.920,2.000 C7.183,2.000 4.956,4.243 4.956,7.000 L4.956,13.000 C4.956,13.020 4.945,13.036 4.944,13.056 C4.941,13.123 4.922,13.185 4.905,13.251 C4.888,13.317 4.873,13.381 4.843,13.440 C4.835,13.458 4.835,13.477 4.826,13.494 L2.279,18.000 L17.565,18.000 L15.018,13.494 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconNotification.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
